import { useMutation } from '@tanstack/react-query'
import { aiStudioService } from '../../../service/aiStudio'

function useDeleteVideoSynthesisRequest() {
  return useMutation({
    mutationKey: ['delete-video-synthesis-request'],
    mutationFn: (requestId: number) => aiStudioService.deleteVideoSynthesisRequest(requestId),
  })
}

export default useDeleteVideoSynthesisRequest